afterCaptchaValidated = function() {
    $("html, body").animate({ scrollTop: $(".g-recaptcha").offset().top }, "slow");
}

window.makeDropdownSelectedBlack = function(element){
    var selectedValue = element.val();
    if( selectedValue == 'none' ){
        element.parent().removeClass('selected');
    }
    else {
        element.parent().addClass('selected');
    }
}

window.equalheight = function(container){
    var currentTallest = 0,
         currentRowStart = 0,
         rowDivs = new Array(),
         $el,
         topPosition = 0;
     $(container).each(function() {

       $el = $(this);
       $($el).height('auto')
       var topPostion = $el.position().top;

       if (currentRowStart != topPostion) {
         for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
           rowDivs[currentDiv].height(currentTallest);
         }
         rowDivs.length = 0; // empty the array
         currentRowStart = topPostion;
         currentTallest = $el.height();
         rowDivs.push($el);
       } else {
         rowDivs.push($el);
         currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
      }
       for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
         rowDivs[currentDiv].height(currentTallest);
       }
     });
}

// Main menu dropdown
$('#toggleMainMenu').on('click', function(event) {
    event.preventDefault();
    $('.primary-navigation').slideToggle();
});

$( "#topics-button" ).click(function(event) {
    event.preventDefault();
    $('#topics-dropdown').toggle();
    $(this).toggleClass('active');
    window.setTopPadding();
});

// Mobile menu toggle
$( ".mobile-navigation-toggle" ).click(function(event) {
    event.preventDefault();
    $(".mobile-menu").toggleClass("show");
    $(this).toggleClass("open");
    $('.mobile-navigation--toggle--icon-label_close').toggleClass("hidden");
    $('.mobile-navigation--toggle--icon-label_menu').toggleClass("hidden");
});


// Initialize form elements
window.initUniform = function(type) {
    type = type || 'all';
    switch(type) {
        case 'select':
            $(".form-select, .form-select-secondary").uniform();
          break;
        case 'checkbox':
            $(".form-checkbox").uniform();
          break;
        case 'radio':
            $(".form-radio").uniform();
          break;
        case 'all':
            $(".form-select, .form-select-secondary, .form-checkbox, .form-radio").uniform();
          break;
        default:
            $(".form-select, .form-select-secondary, .form-checkbox, .form-radio").uniform();
      }
}
window.initUniform();

if( $( ".form-select" ).length )
{
    $( ".form-select" ).each(function( index ) {
        window.makeDropdownSelectedBlack($(this));
    });
}

// Make selected form fields background black
$( ".form-select" ).change(function() {
    window.makeDropdownSelectedBlack($(this));
});


// Scroll to errors
if ( $('.has-error').length) {
    $('html,body').animate({
        scrollTop: $(".has-error").first().offset().top + 'px'
    }, 1000);
}

window.setTopPadding = function() {
    if( $('.sticky').length ){
        var stickyHeight = $('.sticky').innerHeight();
        $(".top-padding").css("padding-top",stickyHeight);
    }
}

$(window).on('load', function() {
    window.setTopPadding();
    $(window).trigger('resize');
    $('.loading').removeClass('loading');
    $('.overlay').remove();
});

$(window).resize(function(){
    window.setTopPadding();
});

$(window).on('load', function() {
    var scrollTohash = {
        initialize: function() {
            if($('.sticky').length) {
                var headerHeight = $('.sticky').height();
                var hashname = window.location.hash.replace('#', '');
                if(hashname.length > 1 && $('#' + hashname)) {
                    elem = $('#' + hashname);
                    if(hashname == 'top') {
                        $('body, html').animate({
                                scrollTop: 0
                            },200);
                        }
                    else {
                         $('body, html').animate({
                            scrollTop: elem.offset().top - headerHeight+"px"
                        },500);
                        elem.addClass("bg-highlight").fadeIn(2000);
                        setTimeout(function () {
                            elem.removeClass("bg-highlight").fadeIn(2000);
                        }, 2000);
                    }
                };
            }

        }
    }
    scrollTohash.initialize();
});

// Warn if overriding existing method
if(Array.prototype.equals)
console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function (array) {
// if the other array is a falsy value, return
if (!array)
    return false;

// compare lengths - can save a lot of time
if (this.length != array.length)
    return false;

for (var i = 0, l=this.length; i < l; i++) {
    // Check if we have nested arrays
    if (this[i] instanceof Array && array[i] instanceof Array) {
        // recurse into the nested arrays
        if (!this[i].equals(array[i]))
            return false;
    }
    else if (this[i] != array[i]) {
        // Warning - two different object instances will never be equal: {x:20} != {x:20}
        return false;
    }
}
return true;
}
// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", {enumerable: false});


